import {
    blogsAdvancedArticleCreateUrl,
    blogsAdvancedArticleEditUrl,
    blogsAdvancedArticlePreviewGridUrl,
    blogsAdvancedArticleUrl,
    blogsAlbumCreateUrl,
    blogsAlbumDetailUrl,
    blogsAlbumEditPhotosUrl,
    blogsAlbumEditUrl,
    blogsAlbumPhotoUrl,
    blogsAlbumReorderUrl,
    blogsArticleCreateUrl,
    blogsArticleDraftsUrl,
    blogsArticleEditUrl,
    blogsArticleUrl,
    blogsAutoMessagePhotoUrl,
    blogsAutoMessageUrl,
    blogsCommentEditUrl,
    blogsEntityLikersUrl,
    blogsFeedWithCategoryUrl,
    blogsFriendsFeedUrl,
    blogsPopularFeedUrl,
    blogsPostShareUrl,
    blogsPostUrl,
    blogsProfileEditProUrl,
    blogsProfileHomeUrl,
    blogsProfileMoreUrl,
    blogsProfileProductsUrl,
    blogsProfileUrl,
    blogsShareMessageUrl,
    blogsShortMessageCreateUrl,
    blogsShortMessageEditUrl,
    blogsShortMessagePhotoUrl,
    blogsShortMessageUrl,
    blogsUrl,
    howtoHomepageUrl,
    recipesHomepageUrl,
} from "@/mk2/apps/blogs/urls";
import { Route } from "@/mk2/containers/Application/Application";
import { url } from "@/mk2/helpers/urls";
import RedirectPage from "@/mk2/pages/RedirectPage";

export const routes: Route[] = [
    {
        app: "blogs",
        path: blogsProfileHomeUrl,
        page: new RedirectPage({
            to: (props) => url(blogsProfileUrl, { username: props.requestUser.username }),
            permanent: true,
            authOnly: true,
        }),
    },
    {
        app: "blogs",
        path: blogsProfileUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/ProfileDetail/ProfileDetailPage" /* webpackChunkName: "blogs.ProfileDetail" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/ProfileDetail/ProfileDetailPage"],
    },
    {
        app: "blogs",
        path: blogsProfileMoreUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/ProfileDetail/ProfileDetailPage" /* webpackChunkName: "blogs.ProfileDetail" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/ProfileDetail/ProfileDetailPage"],
    },
    {
        app: "blogs",
        path: blogsProfileProductsUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/ProfileProducts/ProfileProductsPage" /* webpackChunkName: "blogs.ProfileProducts" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/ProfileProducts/ProfileProductsPage"],
    },
    {
        app: "blogs",
        path: blogsProfileEditProUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/VendorEdit/VendorEditPage" /* webpackChunkName: "blogs.VendorEdit" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/VendorEdit/VendorEditPage"],
    },
    {
        app: "blogs",
        path: blogsUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsFeed/BlogsFeedPage" /* webpackChunkName: "blogs.BlogsFeed" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsFeed/BlogsFeedPage"],
    },
    {
        app: "blogs",
        path: blogsAdvancedArticlePreviewGridUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/AdvancedArticlesPreviewGrid/AdvancedArticlesPreviewGridPage" /* webpackChunkName: "blogs.AdvancedArticlesPreviewGrid" */
            );
        },
        modules: [
            "@/mk2/apps/blogs/containers/AdvancedArticlesPreviewGrid/AdvancedArticlesPreviewGridPage",
        ],
    },
    {
        app: "blogs",
        path: blogsFeedWithCategoryUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsFeed/BlogsFeedPage" /* webpackChunkName: "blogs.BlogsFeed" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsFeed/BlogsFeedPage"],
    },
    {
        app: "blogs",
        path: blogsFriendsFeedUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsFriendsFeed/BlogsFriendsFeedPage" /* webpackChunkName: "blogs.BlogsFriendsFeed" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsFriendsFeed/BlogsFriendsFeedPage"],
    },
    {
        app: "blogs",
        path: blogsPopularFeedUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsPopularFeed/BlogsPopularFeedPage" /* webpackChunkName: "blogs.BlogsPopularFeed" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsPopularFeed/BlogsPopularFeedPage"],
    },
    {
        app: "blogs",
        path: blogsEntityLikersUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsEntityLikers/BlogsEntityLikersPage" /* webpackChunkName: "blogs.BlogsEntityLikers" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsEntityLikers/BlogsEntityLikersPage"],
    },
    {
        app: "blogs",
        path: blogsPostUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsPostSplitter/BlogsPostSplitterPage" /* webpackChunkName: "blogs.BlogsPostSplitter" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsPostSplitter/BlogsPostSplitterPage"],
    },
    {
        app: "blogs",
        path: blogsArticleCreateUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/ArticleCreate/ArticleCreatePage" /* webpackChunkName: "blogs.ArticleCreate" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/ArticleEdit/ArticleCreatePage"],
    },
    {
        app: "blogs",
        path: blogsAdvancedArticleCreateUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/AdvancedArticleCreateEdit/AdvancedArticleCreateEditPage" /* webpackChunkName: "blogs.AdvancedArticleCreateEdit" */
            );
        },
        modules: [
            "@/mk2/apps/blogs/containers/AdvancedArticleCreateEdit/AdvancedArticleCreateEditPage",
        ],
    },
    {
        app: "blogs",
        path: blogsArticleEditUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/ArticleEdit/ArticleEditPage" /* webpackChunkName: "blogs.ArticleEdit" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/ArticleEdit/ArticleEditPage"],
    },
    {
        app: "blogs",
        path: blogsAdvancedArticleEditUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/AdvancedArticleCreateEdit/AdvancedArticleCreateEditPage" /* webpackChunkName: "blogs.AdvancedArticleCreateEdit" */
            );
        },
        modules: [
            "@/mk2/apps/blogs/containers/AdvancedArticleCreateEdit/AdvancedArticleCreateEditPage",
        ],
    },
    {
        app: "blogs",
        path: blogsArticleDraftsUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/ArticleDrafts/ArticleDraftsPage" /* webpackChunkName: "blogs.ArticleDrafts" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/ArticleDrafts/ArticleDraftsPage"],
    },
    {
        app: "blogs",
        path: blogsArticleUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/Article/ArticlePage" /* webpackChunkName: "blogs.Article" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/Article/ArticlePage"],
    },
    {
        app: "blogs",
        path: blogsAdvancedArticleUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/AdvancedArticle/AdvancedArticlePage" /* webpackChunkName: "blogs.AdvancedArticle" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/AdvancedArticle/AdvancedArticlePage"],
    },
    {
        app: "blogs",
        path: blogsCommentEditUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/CommentEdit/CommentEditPage" /* webpackChunkName: "blogs.CommentEditPage" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/CommentEdit/CommentEditPage"],
    },
    {
        app: "blogs",
        path: blogsShortMessageUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetailPage" /* webpackChunkName: "blogs.BlogsShortMessageDetail" */
            );
        },
        modules: [
            "@/mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetailPage",
        ],
    },
    {
        app: "blogs",
        path: blogsAutoMessageUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetailPage" /* webpackChunkName: "blogs.BlogsShortMessageDetail" */
            );
        },
        modules: [
            "@/mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetailPage",
        ],
    },
    {
        app: "blogs",
        path: blogsShareMessageUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetailPage" /* webpackChunkName: "blogs.BlogsShortMessageDetail" */
            );
        },
        modules: [
            "@/mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetailPage",
        ],
    },
    {
        app: "blogs",
        path: blogsShortMessageCreateUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsShortMessageCreate/BlogsShortMessageCreatePage" /* webpackChunkName: "blogs.BlogsShortMessageCreatePage" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsShortMessageEdit/BlogsShortMessageCreatePage"],
    },
    {
        app: "blogs",
        path: blogsShortMessageEditUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsShortMessageEdit/BlogsShortMessageEditPage" /* webpackChunkName: "blogs.BlogsShortMessageEdit" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsShortMessageEdit/BlogsShortMessageEditPage"],
    },
    {
        app: "blogs",
        path: blogsShortMessagePhotoUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsShortMessageImageDetail/BlogsShortMessageImageDetailPage" /* webpackChunkName: "blogs.BlogsShortMessageImageDetail" */
            );
        },
        modules: [
            "@/mk2/apps/blogs/containers/BlogsShortMessageImageDetail/BlogsShortMessageImageDetail",
        ],
    },
    {
        app: "blogs",
        path: blogsAutoMessagePhotoUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsShortMessageImageDetail/BlogsShortMessageImageDetailPage" /* webpackChunkName: "blogs.BlogsShortMessageImageDetail" */
            );
        },
        modules: [
            "@/mk2/apps/blogs/containers/BlogsShortMessageImageDetail/BlogsShortMessageImageDetail",
        ],
    },
    {
        app: "blogs",
        path: blogsAlbumCreateUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsAlbumCreate/BlogsAlbumCreatePage" /* webpackChunkName: "blogs.BlogsAlbumCreate" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsAlbumCreate/BlogsAlbumCreatePage"],
    },
    {
        app: "blogs",
        path: blogsAlbumDetailUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsAlbumDetail/BlogsAlbumDetailPage" /* webpackChunkName: "blogs.BlogsAlbumDetail" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsAlbumDetail/BlogsAlbumDetailPage"],
    },
    {
        app: "blogs",
        path: blogsAlbumReorderUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsAlbumReorder/BlogsAlbumReorderPage" /* webpackChunkName: "blogs.BlogsAlbumReorder" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsAlbumReorder/BlogsAlbumReorderPage"],
    },
    {
        app: "blogs",
        path: blogsAlbumEditUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsAlbumEdit/BlogsAlbumEditPage" /* webpackChunkName: "blogs.BlogsAlbumEdit" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsAlbumEdit/BlogsAlbumEditPage"],
    },
    {
        app: "blogs",
        path: blogsAlbumEditPhotosUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsAlbumEditPhotos/BlogsAlbumEditPhotosPage" /* webpackChunkName: "blogs.BlogsAlbumEditPhotos" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsAlbumEditPhotos/BlogsAlbumEditPhotos"],
    },
    {
        app: "blogs",
        path: blogsAlbumPhotoUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogsAlbumImageDetail/BlogsAlbumImageDetailPage" /* webpackChunkName: "blogs.BlogsAlbumImageDetail" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogsAlbumImageDetail/BlogsAlbumImageDetailPage"],
    },
    {
        app: "blogs",
        path: blogsPostShareUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/blogs/containers/BlogPostShare/BlogPostSharePage" /* webpackChunkName: "blogs.BlogPostShare" */
            );
        },
        modules: ["@/mk2/apps/blogs/containers/BlogPostShare/BlogPostSharePage"],
    },
];
